import useLoggedInUser from '@/composables/logged-in-user/logged-in-user';
import usePrintable from '@/composables/printable/printable';
import useSidebarSvc from '@/composables/logged-in-user/side-bar';
import useSnackBar from '@/composables/snackbar';
import { downloadFromURL } from 'shared/lib/file-download';
import { logCatch } from '@/lib/logger/logger';
import { printableStatus } from 'shared/constants.json';
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';

export default function usePageExport() {
  const { loggedInUser } = useLoggedInUser();
  const { containerWidth } = useSidebarSvc(loggedInUser);
  const snackBar = useSnackBar();

  const { t } = useI18n();

  const printableSvc = usePrintable();
  const exportLoading = ref(false);
  const exportPage = (printable) => {
    exportLoading.value = true;
    if (printable.width === undefined) {
      printable.width = containerWidth.value;
    }
    return printableSvc.createSingle({
      ...printable,
      localStorage: JSON.stringify(localStorage),
      creator: { uid: loggedInUser.value.uid },
    }).then(async (data) => {
      if (data.status !== printableStatus.done) {
        exportLoading.value = false;
        snackBar.error(t('error.pageExport'));
        return;
      }
      await downloadFromURL(data.storageObject.fileName, data.storageObject.getURL);
      exportLoading.value = false;
    }).catch(logCatch(() => {
      exportLoading.value = false;
      snackBar.error(t('error.pageExport'));
    }));
  };
  return { exportPage, exportLoading };
}
